module.exports = __webpack_public_path__ + "static/media/luggers-small-01.5fb573e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photos/luggers-small-01.jpg
// module id = 1282
// module chunks = 27